export const tr = {
  // Common
  "common.back": "Geri",
  "common.cancel": "İptal",
  "common.noItems": "Öğe yok",
  "common.loading": "Yükleniyor...",
  
  // Header
  "nav.features": "Özellikler",
  "nav.howItWorks": "Nasıl Çalışır",
  "nav.pricing": "Fiyatlandırma",
  "nav.faq": "SSS",
  "nav.testimonials": "Vitrin",
  "nav.contact": "İletişim",
  "button.getStarted": "Başla",
  "button.loading": "Yükleniyor...",

  // Auth related
  "auth.signIn": "Giriş Yap",
  "auth.redirecting": "Yönlendiriliyor...",
  "auth.continueWithGoogle": "Google ile Devam Et",
  "auth.continueWithGithub": "GitHub ile Devam Et",
  "auth.or": "VEYA",
  "auth.consent.prefix": "Devam ederek",
  "auth.consent.terms": "Şartlarımızı",
  "auth.consent.and": "ve",
  "auth.consent.privacy": "Gizlilik Politikamızı",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "AI Destekli İletişim Asistanı",
  "hero.subtitle": "Her durumda daha etkili iletişim kurmanıza yardımcı olan akıllı, bağlama duyarlı yanıtlarla konuşmalarınızı dönüştürün.",
  "hero.cta.primary": "Ücretsiz Deneyin",
  "hero.cta.secondary": "Demoyu İzleyin",
  "hero.cta.tryNow": "Ücretsiz Başlayın",
  "hero.cta.learnMore": "Daha Fazla Bilgi",
  "hero.cta.getStarted": "Ücretsiz Başlayın",
  "hero.preview.primary": "Tonu Geliştir",
  "hero.preview.secondary": "Çevir",
  "hero.preview.tone": "Arkadaşça",
  "hero.preview.target": "Müşteri",
  "hero.hook": "Her gün iletişimlerini geliştiren binlerce kullanıcıya katılın.",
  "hero.headline": "AI Destekli İletişim Asistanı",
  "hero.subheadline": "Ham fikirleri birkaç saniye içinde cilalanmış, bağlama uygun yanıtlara dönüştürün.",
  
  // Stats
  "stats.users": "Kullanıcılar",
  "stats.replies": "Yanıtlar",
  "stats.languages": "Diller",

  // Main Title
  "main.title": "Her Yanıtı Bir Fırsata Dönüştürün",

  // Footer Section
  "footer.company": "Şirket",
  "footer.product": "Ürün",
  "footer.support": "Destek",
  "footer.legal": "Yasal",
  "footer.contactSupport": "Destek ile İletişim",
  "footer.helpCenter": "Yardım Merkezi",
  "footer.apiDocs": "API Belgeleri",
  "footer.statusPage": "Durum Sayfası",
  "footer.privacyPolicy": "Gizlilik Politikası",
  "footer.termsOfService": "Hizmet Şartları",
  "footer.cookiePolicy": "Çerez Politikası",
  "footer.refundPolicy": "İade Politikası",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. Tüm hakları saklıdır.",
  "footer.supportLabel": "Destek",

  // Features Section
  "features.badge": "Güçlü Özellikler",
  "features.title": "Daha İyi İletişim İçin ihtiyacınız Olan Her Şey",
  "features.subtitle": "Her konuşmayı daha etkili ve profesyonel hale getirmek için tasarlanmış kapsamlı araçlar.",
  "features.scenario.title": "Senaryo Şablonları",
  "features.scenario.description": "İş yeri, kişisel, akademik ve profesyonel iletişim için önceden oluşturulmuş şablonlar.",
  "features.custom.title": "Özel Girişler",
  "features.custom.description": "Herhangi bir mesajı veya içeriği yapıştırın ve bağlama uygun uygun yanıtlar alın.",
  "features.instant.title": "Yanıtlama Süresini %90 Azaltın",
  "features.instant.description": "Saniyeler içinde AI tarafından oluşturulan yanıtlar alın. Bekleme yok, sadece sonuçlar.",
  "features.copy.title": "Tek Tıkla Kopyalama ve Paylaşma",
  "features.copy.description": "Yanıtları anında kopyalayın veya doğrudan platformdan paylaşın.",

  // How It Works Section
  "howItWorks.badge": "Nasıl Çalışır",
  "howItWorks.title": "Daha İyi İletişim İçin Üç Basit Adım",
  "howItWorks.subtitle": "Basitleştirilmiş sürecimiz, her durum için profesyonel yanıtlar oluşturmayı kolaylaştırır.",
  "howItWorks.step1.title": "Senaryo Seçin",
  "howItWorks.step1.description": "İhtiyaçlarınıza en uygun iletişim senaryosunu seçin.",
  "howItWorks.step2.title": "İçerik Yapıştırın",
  "howItWorks.step2.description": "Yanıtlamanız gereken mesajı veya içeriği ekleyin.",
  "howItWorks.step3.title": "AI Yanıtı Alın",
  "howItWorks.step3.description": "Saniyeler içinde profesyonel, bağlamsal bir yanıt alın.",

  // Pricing Section
  "pricing.title": "Fiyatlandırma",
  "pricing.subtitle": "İletişim ihtiyaçlarınıza uygun planı seçin",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/ay",
  "pricing.free.description": "Hizmetimizi denemek için mükemmel",
  "pricing.pro.description": "Profesyoneller ve sık kullanıcılar için ideal",
  "pricing.business.description": "Takımlar ve organizasyonlar için",
  "pricing.popular": "En Popüler",
  "pricing.free.feature1": "Aylık 10 yanıt",
  "pricing.free.feature2": "Temel senaryo",
  "pricing.free.feature3": "Şablon tanımla ve kullan",
  "pricing.free.feature4": "Geçmiş yanıt kayıtları",
  "pricing.pro.feature1": "Aylık 200 yanıt",
  "pricing.pro.feature2": "Temel+özel senaryo",
  "pricing.pro.feature3": "Şablon tanımla ve kullan",
  "pricing.pro.feature4": "Geçmiş yanıt kayıtları",
  "pricing.pro.feature5": "Gelişmiş özelleştirme",
  "pricing.business.feature1": "Sınırsız yanıt",
  "pricing.business.feature2": "Takım işbirliği",
  "pricing.business.feature3": "Temel+özel senaryo",
  "pricing.business.feature4": "Şablon tanımla ve kullan",
  "pricing.business.feature5": "Geçmiş yanıt kayıtları",
  "pricing.business.feature6": "Gelişmiş özelleştirme",
  "pricing.cta.trial": "Ücretsiz Deneme Başlat",
  "pricing.cta.subscribe": "Abone Ol",
  "pricing.cta.contact": "Satışla İletişime Geç",
  "pricing.cta.current": "Mevcut Plan",
  "pricing.currentPlan": "Mevcut Plan:",
  "pricing.endDate": "Mevcut plan bitiş tarihi:",
  "pricing.autoRenewalDate": "Mevcut plan otomatik yenileme tarihi:",
  "pricing.answersLeft": "Kalan yanıtlar:",
  "pricing.planName.free": "Free Planı",
  "pricing.planName.proMonthly": "Pro Planı-Aylık",
  "pricing.planName.proYearly": "Pro Planı-Yıllık",
  "pricing.planName.maxMonthly": "Enterprise Planı-Aylık",
  "pricing.planName.maxYearly": "Enterprise Planı-Yıllık",
  "pricing.autoRenews": "Yanıt sayınız şu tarihte otomatik olarak yenilenir:",
  "pricing.needMore": "Daha fazla yanıt mı gerekiyor?",
  "pricing.upgradeBelow": "Planınızı aşağıdan yükseltin",
  "pricing.doNotRollOver": "Kullanılmayan yanıtlar devredilmez",
  "pricing.willCancelOn": "İptal edilecek:",
  "pricing.downgradeScheduled": "Düşürme planlandı. Şu plana geçilecek:",
  "pricing.on": "tarihinde:",
  "pricing.upgradeImmediateTitle": "Plan Yükseltildi",
  "pricing.upgradeImmediateDesc": "Yeni planınız artık aktif.",
  "pricing.downgradeScheduledTitle": "Düşürme Planlandı",
  "pricing.downgradeScheduledDesc": "Planınız bir sonraki yenilemede değişecektir.",
  "pricing.cancelScheduledTitle": "İptal Planlandı",
  "pricing.cancelScheduledDesc": "Planınız dönem sonunda sona erecektir.",
  "pricing.cancelResumedTitle": "İptal Kaldırıldı",
  "pricing.cancelResumedDesc": "Aboneliğiniz yenilenmeye devam edecek.",
  "pricing.cancelPendingDowngrade": "İptal",
  "pricing.pendingDowngradeCanceledTitle": "Bekleyen Düşürme İptal Edildi",
  "pricing.pendingDowngradeCanceledDesc": "Planınız değişmeden kalacak.",
  "pricing.pendingDowngradeCancelFailedTitle": "İptal Başarısız",
  "pricing.pendingDowngradeCancelFailedDesc": "Bekleyen düşürme iptal edilemedi. Lütfen tekrar deneyin.",
  "pricing.cancelPendingDowngradeProcessing": "İşleniyor...",
  "pricing.scheduled": "Planlandı",
  "pricing.processing": "İşleniyor...",
  "pricing.getMoreReplies": "Daha Fazla Yanıt Al",
  "pricing.oneTimeTitle": "Hesabınıza daha fazla yanıt alın",
  "pricing.oneTimeAmountLabel": "Tutar (USD)",
  "pricing.repliesUnit": "Yanıtlar",
  "pricing.oneTimeNotice": "Satın aldığınız yanıt sayısı mevcut aylık döngü için geçerlidir. Bunları kullanmak için aktif ücretli abonelik gerekir ve kullanılmayan yanıtlar devredilmez.",
  "pricing.cancel": "İptal",
  "pricing.proceed": "Devam",
  "pricing.confirmUpgradeTitle": "Yükseltmeyi Onayla",
  "pricing.confirmDowngradeTitle": "Düşürmeyi Onayla",
  "pricing.confirmUpgradeDesc": "Planınızı yükseltmek üzeresiniz. Değişiklik hemen yürürlüğe girer ve orantılı ücretler (veya krediler) uygulanabilir.",
  "pricing.confirmDowngradeDesc": "Bir düşürme planlamak üzeresiniz. Mevcut özellikleriniz mevcut faturalandırma döneminin sonuna kadar geçerli kalır.",
  "pricing.downgradeEffectNote": "Düşürme mevcut döngü için geri ödeme yapmaz.",
  "pricing.downgradeApplyNextCycle": "Yeni plan yenileme sırasında otomatik olarak başlar.",
  "pricing.confirmCancel": "Geri",
  "pricing.confirmProceedUpgrade": "Şimdi Yükselt",
  "pricing.confirmProceedDowngrade": "Düşürmeyi Planla",

  // FAQ Section
  "faq.title": "Sık Sorulan Sorular",
  "faq.subtitle": "communicate2win hakkında bilmeniz gereken her şey",
  "faq.q1": "Hangi iletişim senaryoları destekleniyor?",
  "faq.a1": "İş yeri iletişimi, kişisel ilişkiler, akademik yazışmalar, müşteri hizmetleri, satış çıkışı ve birçok diğer senaryoyu destekliyoruz. AI'mız her durum için gerekli bağlam ve tona uyum sağlar.",
  "faq.q2": "Yanıtlar ne kadar hızlı oluşturulur?",
  "faq.a2": "AI'mız yanıtları birkaç saniye içinde oluşturur. Kaliteden ödün vermeden hızı önceliklendiriyoruz, böylece anında profesyonel yanıtlar almanızı sağlıyoruz.",
  "faq.q3": "Aboneliğimi istediğim zaman iptal edebilir miyim?",
  "faq.a3": "Evet, aboneliğinizi istediğiniz zaman iptal edebilirsiniz. Uzun vadeli taahhütler yoktur ve planınızı ihtiyaca göre düşürebilir veya yükseltebilirsiniz.",
  "faq.q4": "Verilerim güvenli ve gizli mi?",
  "faq.a4": "Şifreleme, erişim kontrolleri ve düzenli güvenlik denetimleri dahil olmak üzere kapsamlı güvenlik önlemleri uyguluyoruz. Giriş içeriğiniz ve oluşturulan yanıtlar, yanıt inceleme ve şablon oluşturma gibi özellikleri etkinleştirmek için kullanıcı geçmişinizin bir parçası olarak saklanır. Geçmiş verilerinizi hesap ayarlarınızdan istediğiniz zaman silebilirsiniz.",
  "faq.q5": "Replies biterse ne olur?",
  "faq.a5": "Free kullanıcıları kota yenilenmesi için bir sonraki aylık döngüyü beklemelidir. Pro'ya yükselttikten sonra Replies biterse ek tek seferlik Replies satın alabilirsiniz; bu ek Replies yalnızca mevcut aylık döngü için geçerlidir. Enterprise kullanıcıları sınırsız Replies'e sahiptir.",
  "faq.q6": "Hangi diller destekleniyor?",
  "faq.a6": "Şu anda İngilizceyi destekliyoruz ve İspanyolca, Fransızca, Almanca ve diğer büyük dillere genişleme planlarımız var. AI çok dilli iletişimi etkili bir şekilde yönetebilir.",

  // Testimonials Section
  "testimonials.title": "İletişim Vitrini",
  "testimonials.subtitle": "Kendi yanıtlarınızı ilham almak için kamuya açık mesajlar, e-postalar ve AI ile cilalanmış yanıtlar",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Pazarlama Müdürü",
  "testimonials.sarah.quote": "communicate2win müşteri iletişimi konusunda nasıl yaklaştığımı değiştirdi. Yanıtlar profesyonel ve her hafta saatlerce kazandırıyor.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Satış Müdürü",
  "testimonials.michael.quote": "İş yeri senaryo şablonları inanılmaz derecede doğru. Bu aracı kullanmaya başladığımdan beri yanıt oranım %40 arttı.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Müşteri Başarı Lideri",
  "testimonials.emily.quote": "Zor müşteri durumlarını ele almak için mükemmel. AI bağlamı ve tonu kusursuz şekilde anlıyor.",
  "testimonials.more": "Tam vitrinini keşfetmek için galeriye tıklayın",

  // Interface Elements
  "interface.generating": "Yanıt Oluşturuluyor...",
  "interface.generate": "AI Yanıtı Oluştur",
  "interface.processing": "İşleniyor...",
  "interface.advancedOptions": "Gelişmiş Seçenekler",
  "interface.clearInput": "Girişi Temizle",
  "interface.clearDescription": "Açıklamayı Temizle",
  // Marquee / Logos
  "marquee.trusted": "Ortaklar / Destek",
  "marquee.aria": "Marka Logoları",

  // History and Showcase
  "history.shareToShowcase": "Vitrine Paylaş",
  "history.showcased": "Vitrinde",
  "history.shareConfirm": "Bu gönderi vitrine paylaşılsın mı? Gönderiyi silmediğiniz sürece bu işlem geri alınamaz.",
  "history.sharedBy": "Tarafından paylaşıldı:",
  "interface.copy": "Kopyala",
  "interface.share": "Paylaş",
  "interface.shareResponse": "Yanıtı Paylaş",
  "interface.shareNative": "Sistemle Paylaş",
  "interface.shareEmail": "E-posta",
  "interface.copyShareText": "Bağlantıyla Kopyala",
  "interface.shareTextCopied": "Yanıt ve bağlantı panoya kopyalandı.",
  "interface.ready": "Oluşturmaya Hazır",
  "interface.enterMessage": "Mesaj içeriğinizi girin ve AI destekli yanıtlarla başlamak için bir senaryo seçin.",
  "interface.fast": "Hızlı",
  "interface.accurate": "Doğru",
  "interface.professional": "Profesyonel",
  "interface.translation": "Çeviri",
  "interface.responseDescription": "İşte bağlama uygun düşünülmüş ve profesyonel bir yanıt:",
  "interface.multipleOptions": "Çoklu yanıt seçenekleri:",
  "interface.option": "Seçenek",
  "interface.noContent": "İçerik mevcut değil",

  // Placeholders
  "placeholder.message": "Yanıtladığınız mesajı, e-posta içeriğini veya aldığınız metni yapıştırın...",

  // Dropdowns
  "dropdown.useTemplates": "Şablonları Kullan",
  "dropdown.scenario": "Senaryo Yok",
  "dropdown.target": "Hedef Yok",
  "dropdown.tone": "Ton Yok",

  // Scenario Options
  "scenario.email": "E-posta",
  "scenario.message": "Mesaj",
  "scenario.workplace": "İş Yeri",
  "scenario.school": "Okul",
  "scenario.home": "Ev",
  "scenario.business": "İş",
  "scenario.academic": "Akademik",
  "scenario.social": "Sosyal",
  "scenario.formal": "Resmi",
  "scenario.casual": "Gündelik",
  "scenario.professional": "Profesyonel",
  "scenario.personal": "Kişisel",
  "scenario.customerService": "Müşteri Hizmetleri",
  "scenario.interview": "Mülakat",
  "scenario.presentation": "Sunum",

  // Target Options
  "target.lover": "Aşık",
  "target.friend": "Arkadaş",
  "target.boss": "Patron",
  "target.colleague": "İş Arkadaşı",
  "target.classmate": "Sınıf Arkadaşı",
  "target.parents": "Ebeveynler",
  "target.child": "Çocuk",
  "target.teacher": "Öğretmen",
  "target.student": "Öğrenci",
  "target.client": "Müşteri",
  "target.customer": "Müşteri",
  "target.stranger": "Yabancı",
  "target.family": "Aile",
  "target.sibling": "Kardeş",
  "target.neighbor": "Komşu",
  "target.mentor": "Mentor",
  "target.supplier": "Tedarikçi",
  "target.serviceProvider": "Hizmet Sağlayıcı",
  "target.partner": "Partner",
  "target.subordinate": "Ast",

  // Tone Options
  "tone.humorous": "Mizahi",
  "tone.serious": "Ciddi",
  "tone.happy": "Mutlu",
  "tone.angry": "Kızgın",
  "tone.mischievous": "Yaramaz",
  "tone.polite": "Kibar",
  "tone.casual": "Gündelik",
  "tone.formal": "Resmi",
  "tone.friendly": "Arkadaşça",
  "tone.confident": "Kendinden Emin",
  "tone.apologetic": "Özür Dileyen",
  "tone.enthusiastic": "Hevesli",

  // Status Messages
  "status.copied": "Kopyalandı!",
  "status.copyDescription": "Yanıt panoya kopyalandı.",
  "status.copyWithTranslationDescription": "Yanıt ve çeviri panoya kopyalandı.",
  "status.success": "Yanıt başarıyla oluşturuldu.",
  "status.successWithTranslation": "Yanıt çeviriyle oluşturuldu.",
  "status.successWithoutTranslation": "Yanıt başarıyla oluşturuldu.",
  "status.error": "Oluşturma başarısız",
  "status.errorDescription": "Yanıt oluşturulamadı. Lütfen tekrar deneyin.",
  "status.enterContent": "Lütfen içerik girin",
  "status.enterContentDescription": "Yanıtlamak istediğiniz mesajı ekleyin.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Açıklama (isteğe bağlı)",
  "restriction.descriptionLabel": "Açıklama (Sadece Pro / Enterprise aboneleri için)",
  "restriction.proMaxOnly": "* Sadece Pro / Enterprise aboneleri için",
  "restriction.desPrompt": "Daha iyi yanıtlar oluşturmanıza yardımcı olabilecek bağlam, arka plan bilgisi veya özel gereksinimler girin...",

  // Demo functionality for non-logged-in users
  "demo.title": "Yanıtlamak için bir mesaj seçin",
  "demo.option1": "Satış açılışı (soğuk erişim)",
  "demo.option2": "\"Fiyatınız yüksek\" soruşturma işlemini yönetme",
  "demo.option3": "Mülakat öz tanıtımı (30 saniyelik versiyon)",
  "demo.option4": "E-posta yanıtı",
  "demo.option5": "\"Okundu-ama-yanıt-yok\" olasılığı için takip",
  "demo.option6": "Asansör konuşması (30 saniye)",
  "demo.runDemo": "Demo Çalıştır",
  "demo.inputContent": "Giriş İçeriği:",
  "demo.scenario": "Senaryo:",
  "demo.target": "Hedef:",
  "demo.tone": "Ton:",
  "demo.description": "Açıklama:",

  // Showcase Page
  "showcase.title": "İletişim Vitrini",
  "showcase.subtitle": "Topluluğumuz tarafından paylaşılan ilham verici AI destekli iletişimleri keşfedin",
  "showcase.userPrefix": "Tarafından kamuya açık iletişim",
  "showcase.backAll": "Tüm Vitrinlere Geri Dön",
  "showcase.sortBy": "Sırala:",
  "showcase.sort.newest": "Önce En Yeni",
  "showcase.sort.oldest": "Önce En Eski",
  "showcase.sort.scenario": "Senaryoya Göre",
  "showcase.sort.target": "Hedefe Göre",
  "showcase.sort.tone": "Tona Göre",
  "showcase.filter.scenario": "Senaryo:",
  "showcase.filter.target": "Hedef:",
  "showcase.filter.tone": "Ton:",
  "showcase.filter.all": "Tümü",
  "showcase.loading": "Vitrin yükleniyor...",
  "showcase.loadingUser": "Kullanıcı iletişimi yükleniyor...",
  "showcase.loadingMore": "Daha fazla yükleniyor...",
  "showcase.none.userTitle": "Henüz kamuya açık iletişim yok",
  "showcase.none.globalTitle": "Henüz vitrin öğesi yok",
  "showcase.none.userDesc": "Bu kullanıcı henüz vitrine herhangi bir iletişim paylaşmadı.",
  "showcase.none.globalDesc": "Vitrinde AI iletişiminizi paylaşan ilk kişi olun!",
  "showcase.messageDetails": "Mesaj Detayları",
  "showcase.field.date": "Tarih",
  "showcase.field.scenario": "Senaryo",
  "showcase.field.target": "Hedef",
  "showcase.field.tone": "Ton",
  "showcase.originalMessage": "Orijinal Mesaj",
  "showcase.description": "Açıklama",
  "showcase.aiResponse": "AI Yanıtı",

  // Templates
  "templates.saveAsTemplate": "Şablon olarak kaydet",
  "templates.saved": "Şablon Kaydedildi",
  "templates.saveSuccess": "Şablon başarıyla kaydedildi",
  "templates.title": "Şablonlarım",
  "templates.new": "Yeni Şablon",
  "templates.loading": "Yükleniyor...",
  "templates.none": "Şablon bulunamadı",
  "templates.name": "Ad",
  "templates.scenario": "Senaryo",
  "templates.target": "Hedef",
  "templates.tone": "Ton",
  "templates.description": "Açıklama",
  "templates.save": "Kaydet",
  "templates.saving": "Kaydediliyor...",
  "templates.delete": "Şablonu Sil",
  "templates.deleteConfirm": "Bu şablon silinsin mi?",
  "templates.deleteFailed": "Şablon silinemedi",
  "templates.nameRequired": "* Lütfen şablon adı girin",
  "templates.deleteSuccess": "Şablon başarıyla silindi",

  // History Modal additions
  "history.messageDetails": "Mesaj Detayları",
  "history.messageDetailsDesc": "Orijinal girişi ve AI tarafından oluşturulan yanıtı içeren mesaj ayrıntılarını görüntüleyin ve yönetin.",
  "history.field.date": "Tarih",
  "history.field.scenario": "Senaryo",
  "history.field.target": "Hedef",
  "history.field.tone": "Ton",
  "history.originalMessage": "Orijinal Mesaj",
  "history.aiResponse": "AI Yanıtı",
  "history.description": "Açıklama",
  "history.listTitle": "Mesaj Geçmişi",
  "history.listDesc": "Konuşma geçmişinize göz atın, filtreleyin ve yönetin. Ayrıntıları görüntülemek için herhangi bir mesaja tıklayın.",
  "history.sortBy": "Sırala:",
  "history.sort.newest": "Önce En Yeni",
  "history.sort.oldest": "Önce En Eski",
  "history.sort.scenario": "Senaryoya Göre",
  "history.sort.target": "Hedefe Göre",
  "history.sort.tone": "Tona Göre",
  "history.filter.scenario": "Senaryo:",
  "history.filter.target": "Hedef:",
  "history.filter.tone": "Ton:",
  "history.filter.all": "Tümü",
  "history.loading": "Geçmiş yükleniyor...",
  "history.loadingMore": "Daha fazla yükleniyor...",
  "history.none": "Mesaj bulunamadı",
  "history.showing": "{total} mesajdan {current} tanesi gösteriliyor",
  "history.allLoaded": "Tüm mesajlar yüklendi",
  "history.scrollMore": "Daha fazlası için aşağı kaydırın",
  "history.loadMoreButton": "Daha Fazla Yükle",
  "history.deleteMessage": "Mesajı Sil",
  "history.deleting": "Siliniyor...",
  "history.deleteSuccess": "Mesaj kaydı başarıyla silindi",
  "history.deleteFailed": "Mesaj kaydı silinemedi, lütfen tekrar deneyin",
  "history.confirmDeleteTitle": "Silmeyi Onayla",
  "history.confirmDeleteSubtitle": "Bu işlem geri alınamaz",
  "history.confirmDeleteDesc": "Bu mesaj kaydını silmek istediğinizden emin misiniz?",
  "history.confirmDeleteAction": "Silmeyi Onayla",
  "history.shareTitle": "Vitrine Paylaş",
  "history.shareSubtitle": "Bu mesajı kamuya açık yap",
  "history.sharing": "Paylaşılıyor...",
  "history.confirmShareAction": "Paylaşımı Onayla",
  "history.shareSuccess": "Mesaj vitrine başarıyla paylaşıldı",
  "history.shareFailed": "Vitrine paylaşılamadı, lütfen tekrar deneyin",
  "templates.saveFailed": "Şablon kaydedilemedi",

  // User Menu
  "userMenu.myAccount": "Hesabım",
  "userMenu.history": "Geçmiş",
  "userMenu.templates": "Şablonlar",
  "userMenu.signOut": "Çıkış Yap",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI Yanıtı Önizleme",
  "hero.preview.scenarioLabel": "Senaryo",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Satış Açılışı",
  "demo.shortTitle.priceObjection": "Fiyat İtirazı",
  "demo.shortTitle.interviewIntro": "Mülakat Tanıtımı",
  "demo.shortTitle.emailReply": "E-posta Yanıtı",
  "demo.shortTitle.followUp": "Takip",
  "demo.shortTitle.elevatorPitch": "Asansör Konuşması",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "yanıt",
  "demoTabs.inputPrompt": "GİRİŞ İSTEMİ",
  "demoTabs.context": "BAĞLAM",
  "demoTabs.description": "Açıklama",
  "demoTabs.generate": "Oluştur",
  "demoTabs.aiOutput": "AI ÇIKTISI",
  "demoTabs.sample": "örnek",
  "demoTabs.streaming": "Token akışı...",
  "preview.section.scenarioTemplates.title": "Senaryolar ve Şablonlar",
  "preview.section.scenarioTemplates.subtitle": "Hızlıca bir senaryo seçin veya kaydedilmiş bir şablon uygulayın. Şablonlar açıklama/hedef/ton'u önceden doldurur böylece doğrudan yüksek kaliteli üretimin içine girersiniz.",
  "preview.section.customInputs.title": "Özel Girişler",
  "preview.section.customInputs.subtitle": "Çekirdek giriş + isteğe bağlı açıklama + gelişmiş Senaryo/Hedef/Ton seçiciler. Bağlamsal sonuçlar için serbestçe birleştirin.",
  "preview.section.cutReplyTime.title": "Yanıtlama Süresini %90 Azaltın",
  "preview.section.cutReplyTime.subtitle": "Manuel taslak oluşturma ile AI yardımı karşılaştırması. Paralel seçenekler + yerleşik çeviri veya revizyon döngüleri.",
  "preview.section.copyShare.title": "Tek Tıkla Kopyalama ve Paylaşma",
  "preview.section.copyShare.subtitle": "Birleştirilmiş üst eylemlerle birden fazla seçenek düzenlenmiş: tümünü kopyala / paylaş / seçenek başına kopyala. Çeviri otomatik olarak eklenir.",
  "preview.templates.my": "Şablonlarım",
  "preview.templates.new": "Yeni",
  "preview.manualFlow": "Manuel Akış",
  "preview.aiAssisted": "AI Destekli",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Yapıyı ve tonu planla",
  "preview.manualFlow.step2": "Açılış taslağı oluştur / sil ve yeniden yaz",
  "preview.manualFlow.step3": "Nezaketi ve dilbilgisini ayarla",
  "preview.manualFlow.step4": "Sözcük dağarcığını ara + çeviriyi doğrula",
  "preview.manualFlow.step5": "Hedef uygulamaya yapıştır",
  "preview.copyAll": "Tümünü Kopyala",
  "preview.share": "Paylaş",
  "preview.enPlusTranslation": "EN + Çeviri",
  "preview.translationAppendNote": "(*) Tümünü kopyalarken çeviri otomatik olarak eklenir.",
  "preview.field.scenario": "Senaryo",
  "preview.field.target": "Hedef",
  "preview.field.tone": "Ton",
  "preview.auto": "Otomatik",
  "preview.step.pasteOrTemplate": "İstek yapıştır veya şablon seç",
  "preview.step.optionalDescription": "(İsteğe bağlı) açıklama/senaryo ekle",
  "preview.step.pickOption": "Oluşturulan seçeneklerden birini seç",
  "preview.step.copyShareTranslate": "Tek tıkla kopyala/paylaş/çevir",
  "preview.time.manual": "5–8 dakika",
  "preview.time.ai": "30–40 saniye"
};